//exports.ENV_URL = 'http://localhost:8081/api';
exports.ENV_URL = 'https://luckylotto.erickfranco.com/api';